<template>
  <el-config-provider :locale="currentLocale">
    <router-view />
    <ReDialog />
  </el-config-provider>
</template>

<script lang="ts" setup>
import { ReDialog } from "@/components/ReDialog";
import { ElConfigProvider, ElMessage } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { onMounted, onUnmounted, ref } from "vue";
import { useUserStoreHook } from "@/store/modules/user";

import { useAuth } from "@/utils/authLogin";
import { useRouter } from "vue-router";

const router = useRouter();
const { logout: authLogout, isLoggedIn } = useAuth();

const handleStorageChange = (event) => {
  if (event.key === "user_login_status") {
    if (event.newValue === "logged_out") {
      // 触发退出登录流程
      handleLogout();
    }
  }
};

const handleLogout = () => {
  // 清除本地状态
  // 跳转到登录页
  // router.push('/login')
  useUserStoreHook().logOut();
  // 可以在这里显示退出提示
  showMessage("您已在其他标签页退出登录");
};

// 显示提示消息
const showMessage = (msg) => {
  // 使用 ElMessage 或自定义提示
  ElMessage.info(msg);
};

defineOptions({
  name: "app",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    ReDialog
  }
});

onMounted(() => {
  // 监听 storage 变化
  window.addEventListener("storage", handleStorageChange);
  // 初始检查登录状态
  // if (!isLoggedIn()) {
  //   router.push('/login')
  // }
});

onUnmounted(() => {
  window.removeEventListener("storage", handleStorageChange);
});

const currentLocale = ref(zhCn);
</script>

<style lang="scss">
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  //border: 1px solid;
  text-align: center;
  text-transform: uppercase;
  transition: all 0.2s ease-in-out;
  outline: none;
  box-shadow: inset 0 0 0 1px var(--el-color-primary);

  &:focus {
    box-shadow: inset 0 0 0 2px var(--el-color-primary);
  }
  input::placeholder {
    font-size: 15px;
    text-align: center;
    font-weight: 600;
  }
}

/* Background colour of an input field with value */
//.otp-input.is-complete {
//background-color: #e4e4e4;
//}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
